import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setClear, setUndo } from '../../../store/ToolSlice';

const Canv = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const Canvas = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const canvasRef = useRef(null);
  
  const [getCtx, setGetCtx] = useState(null);
  const [painting, setPainting] = useState(false);
  const [history, setHistory] = useState([]);

  let points = [];
  
  var mouse = {x: 0, y: 0};
  var previous = {x: 0, y: 0};
  
  useEffect(() => {
    // canvas useRef
    const canvas = canvasRef.current;
    canvas.width = 2082;
    canvas.height = 1080;
    
    const ctx = canvas.getContext("2d");
    ctx.lineJoin = "round";
    ctx.lineWidth = 7;
    ctx.strokeStyle = state.tool.mode === 'P' ? 'black' : 'red';
    
    setGetCtx(ctx);
  }, []);

  useEffect(() => {
    if (getCtx) {
      getCtx.strokeStyle = state.tool.mode === 'P' ? 'black' : 'red';
      setGetCtx(getCtx);
    }
  }, [state.tool.mode]);
  
  useEffect(() => {
    if (state.tool.clear) {
      getCtx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      setHistory([]);
      points = [];
    } else if (state.tool.undo) {
      undo();
      getCtx.strokeStyle = state.tool.mode === 'P' ? 'black' : 'red';
    }
    
    dispatch(setClear(false));
    dispatch(setUndo(false));
  }, [state.tool.clear, state.tool.undo]);

  const startDraw = (e, type) => {
    e.preventDefault();
    getCtx.beginPath();

    if (state.tool.mode === 'P' || state.tool.mode === 'R') {
      setPainting(true);

      previous = {x : mouse.x, y : mouse.y};

      if (type === 'M') {
        mouse = {x : e.targetTouches[0].clientX / state.common.zoom, y : (e.targetTouches[0].clientY - state.common.tab) / state.common.zoom};
      } else {
        mouse = {x : e.nativeEvent.offsetX / state.common.zoom, y : e.nativeEvent.offsetY / state.common.zoom};
      }

      points = [];
      points.push({x : mouse.x, y : mouse.y});
    }
  };

  const drawFn = (e, type) => {
    e.preventDefault();
    
    var mouseX = 0;
    var mouseY = 0;
    
    if (state.tool.mode === 'P' || state.tool.mode === 'R') {
      if (type === 'M') {
        mouseX = e.targetTouches[0].clientX / state.common.zoom;
        mouseY = (e.targetTouches[0].clientY - state.common.tab) / state.common.zoom;
      } else {
        mouseX = e.nativeEvent.offsetX / state.common.zoom;
        mouseY = e.nativeEvent.offsetY / state.common.zoom;
      }

      previous = {x:mouse.x,y:mouse.y};

      mouse = {x : mouseX, y : mouseY};

      points.push({x:mouse.x,y:mouse.y})
  
      if (!painting) {
        getCtx.beginPath();
        getCtx.moveTo(mouseX, mouseY);
      } else {
        getCtx.lineTo(mouseX, mouseY);
        getCtx.stroke();
      }
    }
  };

  const endDraw = (e) => {
    e.preventDefault();
    setPainting(false);
    
    if (state.tool.mode === 'P' || state.tool.mode === 'R') {
      setHistory([
        ...history, 
        {
          points : points,
          color : state.tool.mode === 'P' ? 'black' : 'red'
        }
      ]);
      points = [];
    }
  };

  const undo = () => {
    history.splice(-1, 1);

    getCtx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

    history.map((path) => {
      getCtx.strokeStyle = path.color;
      
      getCtx.beginPath();
      getCtx.moveTo(path.points.x,path.points.y);

      (path.points).map((line) => {
        getCtx.lineTo(line.x, line.y); 
      });

      getCtx.stroke();
    });
  };

  return (
    <Canv
      ref={canvasRef}
      onMouseDown={(e) =>startDraw(e, "")}
      onMouseUp={(e) => endDraw(e, "")}
      onMouseMove={(e) => drawFn(e, "")}
      onTouchStart={(e) =>startDraw(e, 'M')}
      onTouchEnd={(e) => endDraw(e, 'M')}
      onTouchMove={(e) => drawFn(e, 'M')}
    />
  );
};